
export const YOUTUBE_REGEX = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

export const VIMEO_REGEX = /^(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)([0-9]+)(?:\S+)?$/;

export const ZOOM_REGEX = /https:\/\/[\w-]*\.?zoom.us\/(j|my|rec\/play)\/[\d\w?=-]+.[\d\w?=-]+/;
